export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5358.87c30a1d.jpg";